<template>
  <div id="downloads">
    <section class="md" v-html="mdfile"></section>
    <div class="row mt-5">
        <div class="col-xl-10">
          <div class="bg-white rounded p-5">
            <table class="table table-borderless">
                <tr>
                    <th>Name</th>
                    <th>Logo</th>
                    <th>Download</th>
                </tr>
                <tr>
                    <td>Favicon</td>
                    <td><img src="@/assets/downloads/logos/pageup/favicon.svg" width="60" /></td>
                    <td><a :href="require(`@/assets/downloads/logos/pageup/favicon.svg`)" download><i class="gel-icon-xs gel-icon-download align-text-bottom"></i>SVG</a> &nbsp; &nbsp;
                        <a :href="require(`@/assets/downloads/logos/pageup/favicon.png`)" download> <i class="gel-icon-xs gel-icon-download align-text-top"></i>PNG</a></td>
                </tr>
                <tr>
                    <td>Favicon with logo</td>
                    <td><img src="@/assets/downloads/logos/pageup/favicon-text.svg" width="60" /></td>
                    <td><a :href="require(`@/assets/downloads/logos/pageup/favicon-text.svg`)" download><i class="gel-icon-xs gel-icon-download align-text-top"></i>SVG</a> &nbsp; &nbsp;
                        <a :href="require(`@/assets/downloads/logos/pageup/favicon-text.png`)" download> <i class="gel-icon-xs gel-icon-download align-text-top"></i>PNG</a></td>
                </tr>
                <tr>
                    <td>PageUp</td>
                    <td><img src="@/assets/downloads/logos/pageup/logo.svg" width="140" /></td>
                    <td><a :href="require(`@/assets/downloads/logos/pageup/logo.svg`)" download><i class="gel-icon-xs gel-icon-download align-text-top"></i>SVG</a> &nbsp; &nbsp;
                        <a :href="require(`@/assets/downloads/logos/pageup/logo.png`)" download> <i class="gel-icon-xs gel-icon-download align-text-top"></i>PNG</a></td>
                </tr>
                <tr>
                    <td>Knowledge Portal</td>
                    <td><img src="@/assets/downloads/logos/knowledgeportal/kp-logo.svg" width="260" /></td>
                    <td><a :href="require(`@/assets/downloads/logos/knowledgeportal/kp-logo.svg`)" download><i class="gel-icon-xs gel-icon-download align-text-top"></i>SVG</a> &nbsp; &nbsp;
                        <a :href="require(`@/assets/downloads/logos/knowledgeportal/kp-logo.png`)" download> <i class="gel-icon-xs gel-icon-download align-text-top"></i>PNG</a></td>
                </tr>
            </table>
          </div>  
        </div>     
        <div class="col-xl-10">
          <div class="bg-navy rounded p-5">
            <table class="table table-borderless table-dark bg-navy">
                <tr>
                    <td>Favicon solid</td>
                    <td><img src="@/assets/downloads/logos/pageup/favicon-reverse.svg" width="60" /></td>
                    <td><a class="text-white" :href="require(`@/assets/downloads/logos/pageup/favicon-reverse.svg`)" download><i class="gel-icon-xs gel-icon-download align-text-top"></i>SVG</a> &nbsp; &nbsp;
                        <a class="text-white" :href="require(`@/assets/downloads/logos/pageup/favicon-reverse.png`)" download> <i class="gel-icon-xs gel-icon-download align-text-top"></i>PNG</a></td>
                </tr>
                <tr>
                    <td>Favicon with logo</td>
                    <td><img src="@/assets/downloads/logos/pageup/favicon-text-reverse.svg" width="60" /></td>
                    <td><a class="text-white" :href="require(`@/assets/downloads/logos/pageup/favicon-text-reverse.svg`)" download><i class="gel-icon-xs gel-icon-download align-text-top"></i>SVG</a> &nbsp; &nbsp;
                        <a class="text-white" :href="require(`@/assets/downloads/logos/pageup/favicon-text-reverse.png`)" download> <i class="gel-icon-xs gel-icon-download align-text-top"></i>PNG</a></td>
                </tr>
                <tr>
                    <td>PageUp</td>
                    <td><img src="@/assets/downloads/logos/pageup/logo-reverse.svg" width="140" /></td>
                    <td><a class="text-white" :href="require(`@/assets/downloads/logos/pageup/logo-reverse.svg`)" download><i class="gel-icon-xs gel-icon-download align-text-top"></i>SVG</a> &nbsp; &nbsp;
                        <a class="text-white" :href="require(`@/assets/downloads/logos/pageup/logo-reverse.png`)" download> <i class="gel-icon-xs gel-icon-download align-text-top"></i>PNG</a></td>
                </tr>
                 <tr>
                    <td>Knowledge Portal</td>
                    <td><img src="@/assets/downloads/logos/knowledgeportal/kp-logo-reverse.svg" width="260" /></td>
                    <td><a class="text-white" :href="require(`@/assets/downloads/logos/knowledgeportal/kp-logo-reverse.svg`)" download><i class="gel-icon-xs gel-icon-download align-text-top"></i>SVG</a>  &nbsp; &nbsp;
                        <a class="text-white" :href="require(`@/assets/downloads/logos/knowledgeportal/kp-logo-reverse.png`)" download> <i class="gel-icon-xs gel-icon-download align-text-top"></i>PNG</a></td>
                </tr>
            </table>
          </div>  
        </div>  
    </div>
  </div>
</template>

<script>
import mdfile from "@/docs/foundations/downloads.md";

// Actual default values
export default {
  name: "downloads",
  beforeCreate: function() {
    this.$emit(
      "update-title",
      this.$root.yamlData.introduction.downloads.name
    );
    this.$emit(
      "update-tagline",
      this.$root.yamlData.introduction.downloads.description
    );
  },
  data() {
    return {
      mdfile
    };
  }
};
</script>
